export const NAV_BACKGROUND_COLOR = '#162B3D';
export const NAV_TEXT_COLOR = '#B6C0C6';
export const NAV_HOVER_COLOR = '#7CE0CC';
export const NAV_HIGHLIGHT_TEXT_COLOR = '#10181E';

export const NAV_SWITCH_SX = {
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: 'primary.light',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: 'primary.light',
  },
};

export const NON_THEME_COLORS = {
  blue: '#1976D2',
  green: '#388E3C',
  orange: '#F57C00',
  purple: '#7B1FA2',
  pink: '#C2185B',
  teal: '#00796B',
  deepPurple: '#5E35B1',
  gray: '#757575',
};
